import { gql } from '@apollo/client'

export const UPDATE_PATIENT_CONTACT_INFO = gql`
  mutation updatePatientContactInfo($input: UpdatePatientContactInfoInput!) {
    updatePatientContactInfo(input: $input) {
      patientId
    }
  }
`
